import Quiz from "./components/Quiz/Quiz.component";
export * from "./components/types";
export * from "./utils";

export default Quiz;
